import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import FormattedCurrency from 'shared/FormattedCurrency';
import AddTickets from 'checkout/views/ticket-picker/components/AddTickets';
import DetailsToggle from '@checkout-s/DetailsToggle'
import ProductConfigurationWrapper from '../../product-picker/containers/ProductConfigurationWrapper';
import ImageGalleryWrapper from '@checkout-s/ImageGalleryWrapper'
import Translation from "../../../../shared/Translation";
import { getXssFilter } from 'checkout/helpers/helpers';

export default class KioskBundle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showDescription: false,
            showProductDescription: false,
        }
    }

    toggleDescription = () => {
        this.setState({showDescription: !this.state.showDescription});
        if (this.state.showDescription === false){
            Object.values(this.props.bundle.contents.products).map((product, i) => {
                if (product.toggle) {
                    product.toggle = false;
                }
            });
        }
    };

    toggleProductDescription = (product) => {
        product.toggle = !product.toggle;
        this.setState({showProductDescription: product.toggle});
    };

    displayGallery = (product) => {
        let imageGallery = <span></span>;
        if (product.images) {
            imageGallery = <span className="image__gallery">
                <ImageGalleryWrapper
                    images={product.images}
                    altTexts={product.images_alt_texts}
                    name={product.name}
                />
            </span>;
        }

        return imageGallery;
    };

    getPriceLevels = () => {
        return Object.values(this.props.bundle.contents.levels).map((priceLevel, i) => {

            let priceLevelDescription = '';
            let interpolations = {};

            if (this.props.isPackage) {

                if (priceLevel.event) {

                    priceLevelDescription = "checkout__for_event";
                    interpolations['event'] = priceLevel.event;

                    if (priceLevel.date) {

                      priceLevelDescription = "checkout__for_event_on_date";
                      interpolations['date'] = priceLevel.date;

                    }

                }

            }

            return (
                <div className="bundle__included-item bundle-price-level" key={priceLevel.id + "_" + i}>
                  <span className="bundle__included-title" key={priceLevel.id}>
                    <Translation interpolation={{quantity:priceLevel.quantity, itemName:priceLevel.name}}>{'checkout__x_quantity'}</Translation>
                    <Translation interpolation={interpolations}>{priceLevelDescription}</Translation>
                  </span>
                </div>
            )
        })
    };

    getProducts = () => {
        return Object.values(this.props.bundle.contents.products).map((product, i) => {
            return (
                <div className="bundle__included-item bundle-product" key={product.id + "_" + i}>
                    <span className="bundle__included-title" key={product.product_id}><Translation interpolation={{quantity:product.quantity, itemName:product.name}}>{'checkout__x_quantity'}</Translation></span><DetailsToggle onClick={this.toggleProductDescription} index={product}/>
                    {product.toggle &&
                        <div className="bundle-product__more card">
                            {this.displayGallery(product)}
                            <div
                              className="ticket-description__content"
                              dangerouslySetInnerHTML={{
                                __html: getXssFilter().process(product.description)
                              }}
                            />
                        </div>
                    }
                </div>
            )
        })
    };

    displayBundleProductConfiguration = () => {
        if (this.props.bundleQuantity > 0) {
            let productConfigLines = [];
            Object.values(this.props.bundle.contents.products).map((product, index) => {
                let total = 0;
                if (!product.single_configuration) {
                    productConfigLines.push(<div key={index} className="product__configuration__title ticket__name" id={product.product_id}>{product.name}</div>);
                    for (let i = 0; i < this.props.bundleQuantity; i++) {
                        for(let j = 0; j < product.quantity; j++) {
                            productConfigLines.push(
                                <div className="product__configuration__option" key={'bundle_' + product.product_id + '_' + i + j}>
                                    <ProductConfigurationWrapper
                                        key={i}
                                        product={product}
                                        configKey={total}
                                        productQuantity={+product.quantity}
                                        bundleQuantity={this.props.bundleQuantity}
                                        bundle={this.props.bundle}
                                    />
                                </div>
                            );
                            total++;
                        }
                    }
                }
            });

            return (productConfigLines.length > 0 &&
                <div className="product__configurations__wrapper">
                    {productConfigLines}
                </div>
            );
        }
    };

    getBundleDetails = () => {
        return (
            <div className="ticket-description__content" name="description_{index}">
                <div className={`ticket-description__more bundle__content ${this.props.bundle.description ? 'card-group' : ''}`} >
                    <div className="card">
                        <span className="bundle-includes__text"><Translation>{'checkout__bundle_includes'}</Translation></span>
                        <span className="bundle-includes">
                            {this.getPriceLevels()}
                            {this.getProducts()}
                        </span>
                    </div>
                    {this.props.bundle.description ?
                        <div
                          className="ticket-description__content-desc card"
                          dangerouslySetInnerHTML={{
                            __html: getXssFilter().process(this.props.bundle.description)
                          }}
                        />
                        : ''
                    }
                </div>

            </div>
        )
    };

    onIncrement = () => {
        this.props.onIncrement(this.props.bundle);
    };

    onDecrement = () => {
        this.props.onDecrement(this.props.bundle.id);
    };

    render() {
        return <Fragment>
            <div className="ticket">
                <div className="ticket__information">
                    <div className="ticket__name">{ this.props.bundle.name }</div>
                    <div className="ticket__pricing-group">
                        <div className="ticket__price"><FormattedCurrency>{ this.props.bundle.price.amount }</FormattedCurrency> + <FormattedCurrency>{ this.props.bundle.service_fee.price }</FormattedCurrency> <Translation>{'checkout__fee'}</Translation></div>
                    </div>
                    <DetailsToggle
                      onClick={this.toggleDescription}
                      aria-expanded={this.state.showDescription}
                      aria-controls={`description_bundle_${this.props.bundle.id}`}
                    />
                </div>

                <div className="ticket__action">
                    <AddTickets
                        onIncrement={this.onIncrement}
                        onDecrement={this.onDecrement}
                        quantity={this.props.bundleQuantity}
                        quantities={this.props.quantities}
                        onQuantityInput={this.props.onQuantityChange}
                        initialQuantities={this.props.initialQuantities}
                    />
                </div>
            </div>
            {this.state.showDescription && (
              <div
                id={`description_bundle_${this.props.bundle.id}`}
                className="ticket__description"
              >
                  {this.getBundleDetails()}
              </div>
            )}


            {this.displayBundleProductConfiguration()}
        </Fragment>
    }
}

KioskBundle.propTypes = {
    bundle: PropTypes.object,
    onIncrement: PropTypes.func.isRequired,
    onDecrement: PropTypes.func.isRequired,
    onQuantityChange: PropTypes.func.isRequired,
    bundleQuantity: PropTypes.number,
    initialQuantities: PropTypes.arrayOf(PropTypes.number),
    quantities: PropTypes.arrayOf(PropTypes.number),
};
